module.exports = __webpack_public_path__ + "img/item_3.201bf0b3.png";